/**
 * Main Hero Component
 * 
 * @module components/main-hero
 */

import Component from './component';
import utils from '../utils';

export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  'use strict';

  /**
   * MainHero component class
   */
  class MainHero extends Component {
    constructor(element, options = {}) {
      super(element, options);
      this.name = 'main-hero';
    }

    /**
     * Main initializer
     * 
     * @returns void
     */
    init() {
      const el = this.element;

      if (el.hasClass(this.initializedClass)) {
        return;
      }

      el.addClass(this.initializedClass);

      // wait full page load before show the video
      /*
       * DEV NOTE: must use special event isloaded because this script 
       * might run AFTER the window load has been fired
       */
      $(window).one('isloaded', this.initLoaded.bind(this));
    }

    initLoaded() {
      this.showingVideo = false;
      this.maybeShowVideo();
    }

    maybeShowVideo() {
      // the video already showing, skip
      if (this.showingVideo) {
        return true;
      }

      // we are on mobile, never show the video, just watch for resize
      if (this.isMobile()) {
        if (!this._onResize) {
          this._onResize = utils.debounce(this.maybeShowVideo.bind(this), 300);
          window.addEventListener('resize', this._onResize);
        }

        return false;
      }

      this.showingVideo = true;

      // after the video is shown, we don't need top watch resize anymore
      if (this._onResize) {
        window.removeEventListener('resize', this._onResize);
        this._onResize = null;
      }

      // add a bit delay
      window.setTimeout(() => {
        this.initVideo();
      }, 800);
      
      return true;
    }

    initVideo() {
      const el = this.element;

      $('.main-hero--bg-video video source[data-src]', el).each(async (idx, source) => {
        // need to create a clone, otherwise the video won't show
        const org = $(source);
        const s = org.clone();
        s.prop('src', org.attr('data-src'));
        s.appendTo(org.parent());
        org.remove();
      });

      window.requestAnimationFrame(() => {
        el.addClass('-video-loaded');
      });
    }
  }

  MainHero.selectors = {
  };

  // MainHero.plyr = undefined;

  return MainHero;
})(jQuery, window);